'use client';
import { ComponentType } from 'react';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { Props } from './youtube-player.component';
import dynamic from 'next/dynamic';

const DynamicYoutubePlayerComponent: ComponentType<Props> = dynamic(
  () => import('./youtube-player.component')
);

export default DynamicYoutubePlayerComponent;

export function calculateYoutubePlayerPlaceholderConfig(props: Props): PlaceholderConfig {
  const contentHtmlHeight: number = props.height;

  const heightSinceWidth = [
    { sinceWidth: 0, height: contentHtmlHeight / 2 + 48 },
    { sinceWidth: 768, height: contentHtmlHeight / 2 + 48 },
    { sinceWidth: 1024, height: contentHtmlHeight / 2 + 48 },
    { sinceWidth: 1440, height: contentHtmlHeight / 2 + 48 }
  ];

  return {
    heightSinceWidth
  };
}
